module.exports = __webpack_public_path__ + "static/media/update.e1a002d6.svg";